module.exports = __webpack_public_path__ + "img/banner.72346307.png";